'use client';

import { Separator } from '@eliadmin/core/src/components/ui/separator';
import { CacheKey } from '@eliadmin/core/src/api/constants';
import { fetchLanguages, fetchRegions } from '@eliadmin/core/src/api/general/general-api';
import { fetchJobCategories } from '@eliadmin/core/src/api/jobportal/categories-api';
import { fetchEmploymentTypes } from '@eliadmin/core/src/api/jobportal/create-curriculum-api';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import { useLocaleStore } from '@eliadmin/core/src/stores/locale-store';
import { useQuery } from '@tanstack/react-query';
import { CheckboxesFilter } from '../../../filter/fields/jobportal-filter-checkboxes';
import { useJobportalCurriculumsStore } from '@eliadmin/core/src/stores/jobportal-curriculums-store';

const placeOfWorkOptions = [
  { label: 'On site', value: '1' },
  { label: 'Z domu', value: '2' },
];

const educationOptions = [
  { label: 'Základné', value: '1' },
  { label: 'Stredoškolské', value: '2' },
  { label: 'Vysokoškolské', value: '3' },
];

export const CurriculumsFilterContent = () => {
  const { t } = useTranslations();
  const locale = useLocaleStore(s => s.currentLocale);

  const { setFilter, filter } = useJobportalCurriculumsStore();

  const { data: categories } = useQuery({
    queryKey: [CacheKey.JOBPORTAL_CATEGORIES],
    queryFn: () =>
      fetchJobCategories({ locale, query: { results: 150 } }).then(r =>
        r.data.map(g => ({ label: g.name, value: g.id.toString() })),
      ),
  });

  const { data: employmentTypes } = useQuery({
    queryKey: [CacheKey.JOBPORTAL_EMPLOYMENT_TYPES],
    queryFn: () =>
      fetchEmploymentTypes({ locale }).then(r =>
        r.data.map(g => ({ label: g.name, value: g.id.toString() })),
      ),
  });

  const { data: regionOptions } = useQuery({
    queryKey: [CacheKey.REGIONS],
    queryFn: () =>
      fetchRegions({ locale }).then(r =>
        r.data.map(g => ({ label: g.name, value: g.id.toString() })),
      ),
  });

  const { data: languages } = useQuery({
    queryKey: [CacheKey.LANGUAGES],
    queryFn: () =>
      fetchLanguages().then(r => r.data.map(g => ({ label: g.name, value: g.id.toString() }))),
  });

  return (
    <>
      {categories && (
        <CheckboxesFilter
          title={t('text176')}
          search
          searchPlaceholder={'Vyhľadať kategóriu'}
          sortBySelected
          options={categories}
          selectedOptions={
            categories
              .filter(val => filter.categories?.find(val2 => val2 === val.value))
              .map(val3 => val3.value) ?? []
          }
          onChange={(newCategories: any) => {
            setFilter({ categories: newCategories });
          }}
        />
      )}
      {/* <Separator className="bg-[#D8D8DB]" />
      <CheckboxesFilter
        title={t('text864')}
        options={educationOptions}
        selectedOptions={
          educationOptions
            .filter(val => filter.educations?.find(val2 => val2 === val.value))
            .map(val3 => val3.value) ?? []
        }
        onChange={(newEducations: any) => {
          setFilter({ educations: newEducations });
        }}
      /> */}
      <Separator className="bg-[#D8D8DB]" />
      {/* <CheckboxesFilter
        title={t('text903')}
        options={regionOptions || []}
        selectedOptions={
          regionOptions
            ?.filter(val => filter.regions?.find(val2 => val2 === val.value))
            .map(val3 => val3.value) ?? []
        }
        onChange={(newRegions: any) => {
          setFilter({ regions: newRegions });
        }}
      />
      <Separator className="bg-[#D8D8DB]" /> */}
      {languages && (
        <CheckboxesFilter
          title={t('text1612')}
          options={languages}
          selectedOptions={
            languages
              ?.filter(val => filter.languages?.find(val2 => val2 === val.value))
              .map(val3 => val3.value) ?? []
          }
          onChange={(newLanguages: any) => {
            setFilter({ languages: newLanguages });
          }}
        />
      )}
      <Separator className="bg-[#D8D8DB]" />
      {employmentTypes && (
        <CheckboxesFilter
          title={t('text797')}
          options={employmentTypes}
          selectedOptions={
            employmentTypes
              .filter(val => filter.employment_types?.find(val2 => val2 === val.value))
              .map(val3 => val3.value) ?? []
          }
          onChange={(newEmploymentTypes: any) => {
            setFilter({ employment_types: newEmploymentTypes });
          }}
        />
      )}
      {/* <Separator className="bg-[#D8D8DB]" />
      <CheckboxesFilter
        title={t('text1514')}
        options={placeOfWorkOptions}
        selectedOptions={
          placeOfWorkOptions
            .filter(val => filter.places_of_work?.find(val2 => val2 === val.value))
            .map(val3 => val3.value) ?? []
        }
        onChange={(newPlacesOfWork: any) => {
          setFilter({ places_of_work: newPlacesOfWork });
        }}
      /> */}
    </>
  );
};
